function removeVietnameseTones(str = "") {
  if (typeof str !== "string") {
    if (typeof str === "number") return str.toString();
    else return str;
  }
  return str
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .replace(/đ/g, "d")
    .replace(/Đ/g, "d");
}

export function formatSearchString(searchTerm) {
  return removeVietnameseTones(searchTerm);
}
